import { useQuery } from '@tanstack/react-query';
import { graphql } from '../gql/gql';
import { graphqlRequest, shouldRetryQuery } from '../utils/graphqlClient';
import { GetCountryLandingDataQuery } from '../gql/graphql';

const getCountryLandingData = graphql(/* GraphQL */ `
  query getCountryLandingData($countryId: Int, $slug: String) {
    countryLandingData(countryId: $countryId, slug: $slug) {
      countryId
      countryName
      minPrice
      maxPrice
      currency
      departureCount
      nextDepartureDate
      routes {
        routeId
        routeName
        routeImageUrl
        isTopDestination
        departureCount
      }
      boats {
        boatId
        name
        slug
        currency
        minPrice
        heroImageUrl
      }
    }
  }
`);

const useGetCountryLandingData = (
  params: { countryId?: number; slug?: string },
  enabled = true,
) => {
  const { countryId, slug } = params;
  const hasIdentifier = Boolean(countryId || slug);

  const { data, isLoading } = useQuery<GetCountryLandingDataQuery>({
    queryKey: ['countryLandingData', countryId ?? null, slug ?? null],
    queryFn: async () =>
      graphqlRequest<GetCountryLandingDataQuery>(getCountryLandingData, {
        countryId: countryId ?? null,
        slug: slug ?? null,
      }),
    enabled: enabled && hasIdentifier,
    retry: shouldRetryQuery,
    staleTime: 5 * 60 * 1000,
  });

  return {
    countryLandingData: data?.countryLandingData ?? null,
    countryLandingLoading: isLoading,
  };
};

export default useGetCountryLandingData;
